import { selectFormat } from "components/Utils/Utils";
import React, { useState } from "react";
import HeatMap from "react-heatmap-grid";
import { Tooltip as ReactTooltip } from "react-tooltip";

const xLabels = new Array(24).fill(0).map((_, i) => `${i}`);

// Display only even labels
const xLabelsVisibility = new Array(24)
  .fill(0)
  .map((_, i) => (i % 2 === 0 ? true : false));

const yLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const HearstImpressionsDayTime = (props) => {
  const data = yLabels.map((dof) =>
    props.data.data
      .filter((d) => d.day_of_week === dof)
      .sort((a, b) => a.hour_of_day - b.hour_of_day)
      .map((d) => d.display_impressions)
  );
  const [content, setContent] = useState(2344.6200000000013);
  return (
    <div style={{ fontSize: "13px" }}>
      <HeatMap
        xLabels={xLabels}
        yLabels={yLabels}
        xLabelsLocation={"bottom"}
        xLabelsVisibility={xLabelsVisibility}
        xLabelWidth={60}
        data={data}
        squares
        height={45}
        // onClick={(x, y) => alert(`Clicked ${x}, ${y}`)}
        cellStyle={(background, value, min, max, data, x, y) => ({
          background: `rgb(252, 109, 82, ${1 - (max - value) / (max - min)})`,
          fontSize: "11.5px",
          color: "#444",
        })}
        cellRender={(value) => {
          return (
            value && (
              <div
                data-tooltip-id="HearstImpressionsDayTime"
                data-tooltip-html={content}
                title=""
                style={{ width: "100%", height: "100%" }}
                onMouseEnter={() => setContent(selectFormat("number", value))}
                onMouseLeave={() => setContent(null)}
              >
                {selectFormat("number", value)}
              </div>
            )
          );
        }}
      ></HeatMap>
      <ReactTooltip id="HearstImpressionsDayTime" />
    </div>
  );
};

export default HearstImpressionsDayTime;
